import {
  getAccessConfig,
  getBiasColor,
  getBiasLabel,
  getReliabilityDots,
  getReliabilityLabel,
} from '@/utils/outlets'
import { RiExternalLinkLine, RiLockLine, RiTimeLine } from 'react-icons/ri'
import { NewsFavicon } from '../NewsFavicon'
import Tooltip from '../tooltip'
import { Button } from '../ui/Button'

const ACCESS_ICONS = {
  Paid: RiLockLine,
  Limited: RiTimeLine,
}

export default function OutletCard({ outlet }) {
  const biasLabel = getBiasLabel(outlet.bias)
  const biasColor = getBiasColor(outlet.bias)
  const reliabilityDots = getReliabilityDots(outlet.reliability)
  const reliabilityLabel = getReliabilityLabel(outlet.reliability)
  const accessConfig = getAccessConfig(outlet.access)
  const AccessIcon = ACCESS_ICONS[outlet.access]

  return (
    <article className="bg-card border border-border rounded-sm p-5 hover:border-foreground transition-colors">
      {/* Outlet Image or Favicon */}
      <div className="flex justify-center mb-4">
        <NewsFavicon
          className="inline-block rounded-full"
          src={`${process.env.NEXT_PUBLIC_SUPABASE_URL}/storage/v1/object/public/public_assets/news-favicons/${outlet.slug}.jpg`}
          faviconSize="xl"
          alt={`${outlet.name} logo`}
        />
      </div>

      {/* Card Content */}
      <h2 className="font-serif text-lg font-bold text-foreground text-center mb-4">
        {outlet.name}
      </h2>

      {/* Visual Indicators */}
      <div className="space-y-3 mb-5">
        {/* Bias */}
        <div className="flex items-center justify-between">
          <span className="text-xs font-sans text-muted-foreground">Bias</span>
          <div className="flex items-center gap-2">
            <span className={`w-3 h-3 rounded-full ${biasColor}`} />
            <span className="text-xs font-medium">{biasLabel}</span>
          </div>
        </div>

        {/* Reliability */}
        <div className="flex items-center justify-between">
          <span className="text-xs font-sans text-muted-foreground">Reliability</span>
          <div className="flex items-center gap-2">
            <div className="flex gap-0.5">
              {[1, 2, 3, 4].map((dot) => (
                <span
                  key={dot}
                  className={`w-2 h-2 rounded-full ${
                    dot <= reliabilityDots
                      ? 'bg-green-500'
                      : 'bg-muted-foreground/20'
                  }`}
                />
              ))}
            </div>
            <span className="text-xs font-medium">{reliabilityLabel}</span>
          </div>
        </div>

        {/* Access */}
        <div className="flex items-center justify-between">
          <span className="text-xs font-sans text-muted-foreground">Access</span>
          <Tooltip message={accessConfig.tooltip}>
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-xs font-medium ${accessConfig.className}`}>
              {AccessIcon && <AccessIcon className="w-3 h-3" />}
              {accessConfig.label}
            </span>
          </Tooltip>
        </div>
      </div>

      <Button
        variant="outline"
        size="sm"
        className="w-full"
        href={outlet.website}
        target="_blank"
      >
        <RiExternalLinkLine className="w-4 h-4 mr-2" />
        Visit Website
      </Button>
    </article>
  )
}
